import Vue from 'vue'

// 状态
Vue.filter('goodStatus', function (val, type) {
  const mapObj = {
    1: '已参与',
    2: '立即参与',
    3: '已抢完',
    4: '已结束',
    5: '即将开始'
  }
  return mapObj[val];
})

// 分换算
Vue.filter('fentoYuan', function (val) {
  // return Math.round(val / 100)
  return val / 100
})

  // 地址类别
Vue.filter('addressType', function (val, type) {
    const mapObj = {
      0: '注册地址',
      1: '整间出租',
      2: '面积出租',
    }
    return mapObj[val];
  })



// WEBPACK FOOTER //
// ./src/utils/filters.js